import React, {useState, useEffect, useMemo} from 'react';
import { Button, StyleSheet, TextInput, TouchableOpacity, View } from 'react-native'

import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import api from '../../../../../utils/api';
import { useQuery } from '@tanstack/react-query';
import Header from '../../../../../navigation/Header';
import { ScrollView } from 'react-native-gesture-handler';
import IconButton from '../../../../../components/IconButton';
import FilePicker from '../../../../../components/FilePicker';
import useFormSubmit from '../../../../../hooks/useFormSubmit';
import useActiveResidentCommunity from '../../../../../hooks/useActiveResidentCommunity';
import * as Clipboard from 'expo-clipboard';
import { useToast } from 'react-native-toast-notifications';


function BankTransferInfo({bankingInfo}){
  const toast = useToast()

  const copyToClipboard = async (text, fieldName) => {
    await Clipboard.setStringAsync(text);
    toast.show(`${fieldName} copiado al portapapeles`)
  }
  
  return (
    <View style={tw`bg-white rounded-xl mb-6`}>
      <View style={tw`row pl-4 pr-3 py-3 border-b border-gray-100`}>
        <Text style={tw`w-24`}>Banco</Text>
        <Text style={tw`flex-1`}>{bankingInfo.bank_name}</Text>
      </View>

      <TouchableOpacity style={tw`row pl-4 pr-3 py-3 border-b border-gray-100`} onPress={() => copyToClipboard(bankingInfo.account_number, 'Número de cuenta')}>
        <Text style={tw`w-24`}>Cuenta</Text>
        <Text style={tw`flex-1`}>{bankingInfo.account_number}</Text>
      </TouchableOpacity>

      <TouchableOpacity style={tw`row pl-4 pr-3 py-3 border-b border-gray-100`} onPress={() => copyToClipboard(bankingInfo.clabe, 'CLABE')}>
        <Text style={tw`w-24`}>CLABE</Text>
        <Text style={tw`flex-1`}>{bankingInfo.clabe}</Text>
      </TouchableOpacity>

      <TouchableOpacity style={tw`row pl-4 pr-3 py-3 border-b border-gray-100`} onPress={() => copyToClipboard(bankingInfo.owner_name, 'Titular')}>
        <Text style={tw`w-24`}>Titular</Text>
        <Text style={tw`flex-1`}>{bankingInfo.owner_name}</Text>
      </TouchableOpacity>

      {
        bankingInfo.email &&
          <TouchableOpacity style={tw`row pl-4 pr-3 py-3`} onPress={() => copyToClipboard(bankingInfo.email, 'email')}>
            <Text style={tw`w-24`}>email</Text>
            <Text style={tw`flex-1`}>{bankingInfo.email}</Text>
          </TouchableOpacity>
      }
    </View>
  )
}


export function FeeInfoBlock({feeUnit, compact=false}){
  return (
    <View style={tw`bg-white px-3 py-2 rounded-xl  mb-6`}>
      <View style={tw.style(`row justify-between items-start mb-4`, compact && `mb-0`)}>
        <View style={tw`flex-1`}>
          <Text style={tw`text-base font-500 text-secondary`}>{feeUnit.fee.name}</Text>
          <Text style={tw`text-gray-400`}>{feeUnit.fee.type.name}</Text>
        </View>

        {
          ! compact ?
            <Text style={tw.style(`text-red-500 font-600`, feeUnit.is_paid && "text-green-500")}>{feeUnit.is_paid ? "Pagado" : "Por pagar"}</Text>
          :
            <Text style={tw`text-red-500 font-600`}>${feeUnit.pending}</Text>
        }
      </View>

      {
        ! compact &&
          <>
            <View style={tw`row justify-between`}>
              <Text style={tw`text-gray-400`}>Monto</Text>

              <Text style={tw`text-gray-600 font-600 text-gray-600`}>${feeUnit.amount}</Text>
            </View>

            {
              feeUnit.paid > 0 &&
                <View style={tw`row justify-between`}>
                  <Text style={tw`text-gray-400`}>Monto Pagado</Text>

                  <Text style={tw`text-primary font-600`}>${feeUnit.paid}</Text>
                </View>
            }

            {
              feeUnit.pending > 0 &&
                <View style={tw`row justify-between`}>
                  <Text style={tw`text-gray-400 text-red`}>Pendiente de pago</Text>

                  <Text style={tw`text-gray-600 font-600 text-red text-xl`}>${feeUnit.pending}</Text>
                </View>
            }
          </>
      }
    </View>
  )
}


export default function BankTransferPaymentScreen({navigation, route}) {
  const { unit_fee_ids, unitId, return_to_unit_fee_id } = route.params

  const { community, communityId } = useActiveResidentCommunity()

  const [showEvidenceScreen, setShowEvidenceScreen] = useState(false);

  // const { isLoading, error, data: feeUnit, refetch } = useQuery({
  //   queryKey: ['unit-fee.detail', communityId, unit_fee_id],
  //   queryFn: () => api.get(`/communities/${communityId}/unit-fees/${unit_fee_id}`).then(response => response.data),
  // })

  const { isLoading, error, data: unitFees, refetch } = useQuery({
    queryKey: ['unit.fees', communityId, unitId],
    queryFn: () => api.get(`/communities/${communityId}/units/${unitId}/fees`).then(response => response.data),
  })


  const filteredUnitFees = useMemo(() => {
    return unitFees?.filter(unitFee => unit_fee_ids.indexOf(unitFee.uuid) !== -1)
  }, [unitFees])


  //! 
  //! 
  //! Cuando se puedan elegir multiples pagos arreglar esto!!
  //! 
  //! 
  const feeUnit = filteredUnitFees?.[0]


  const goToEvidenceUploadScreen = () => navigation.navigate("Resident.UnitFeesPayment.BankTransfer.PaymentEvidenceUpload", {
    feeUnits: filteredUnitFees,
    return_to_unit_fee_id,
  })



  // return <View style={tw`pt-30 px-5`}>
  //   <Text>jaja {filteredUnitFees?.length}</Text>
  //   <Text>{JSON.stringify(unit_fee_ids)}</Text>
  // </View>;
  
  return (
    <View style={tw`flex-1 bg-white`}>
      <View style={tw`bg-secondary rounded-b-2xl mb-6`}>
        <Header showBackButton backButtonColor='white' style={tw`bg-transparent`}>
          <Text style={tw`text-xl text-white mt-0.5`}>Pagar adeudo</Text>
        </Header>

        <View style={tw`px-5`}>
          {
            feeUnit &&
              <FeeInfoBlock feeUnit={feeUnit} compact={true} />
          }

          {/* Info bancaria */}
          {
            community.settings?.banking_details &&
              <View style={tw``}>
                <Text style={tw`text-white mb-4 pl-4`}>Datos bancarios</Text>

                <BankTransferInfo bankingInfo={community.settings?.banking_details} />
              </View>
          }
        </View>
      </View>

      {
        feeUnit &&
          <>
            <View style={tw`px-4`}>

              {/* Sección ¿Ya pagaste? envía comprobante */}
              <View style={tw`bg-gray-200 py-6 px-6 rounded-xl`}>
                <Text style={tw`font-600 text-center text-xl mb-4`}>¿YA PAGASTE?</Text>

                <IconButton
                  title={'Envía tu comprobante'}
                  icon=''
                  style={tw`py-2`}
                  onPress={goToEvidenceUploadScreen}
                />
              </View>
            </View>
          </>
      }
    </View>
  );
}
